import { ComponentChildren, FunctionalComponent, h } from "preact";
import { TabItemContentStyled, TabItemTitleStyled, TabsContentStyled } from "./tabs.style";

export interface TabItemTitleProps {
  callbackOnClick: (data: any) => void;
  title: string,
  isActive: boolean
}

export interface TabItemContentProps {
  children: ComponentChildren,
  isActive: boolean
}

export interface TabsProps {
  children: ComponentChildren
}

export const TabItemTitle: FunctionalComponent<TabItemTitleProps> = ({
  callbackOnClick,
  title,
  isActive
}) => {
  return (
    <TabItemTitleStyled isActive={isActive} onClick={callbackOnClick}>
      {title}
    </TabItemTitleStyled>
  )
};

export const TabItemContent: FunctionalComponent<TabItemContentProps> = ({
  children,
  isActive
}) => {
  return (
    <TabItemContentStyled isActive={isActive}>
      {children}
    </TabItemContentStyled>
  )
};

export const Tabs: FunctionalComponent<TabsProps> = ({
  children
}: TabsProps) => {
  return (
    <TabsContentStyled>
      {children}
    </TabsContentStyled>
  )
};